var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import React from 'react';
import Typography from './Typography';
var typographyElementsToGenerate = [
    {
        displayName: 'Heading1',
        semanticTag: 'h1',
        defaultVisualAppearance: 'heading-xxl',
    },
    {
        displayName: 'Heading2',
        semanticTag: 'h2',
        defaultVisualAppearance: 'heading-xl',
    },
    {
        displayName: 'Heading3',
        semanticTag: 'h3',
        defaultVisualAppearance: 'heading-lg',
    },
    {
        displayName: 'Heading4',
        semanticTag: 'h4',
        defaultVisualAppearance: 'heading-md',
    },
    {
        displayName: 'Heading5',
        semanticTag: 'h5',
        defaultVisualAppearance: 'heading-sm',
    },
    {
        displayName: 'Heading6',
        semanticTag: 'h6',
        defaultVisualAppearance: 'heading-xs',
    },
    {
        displayName: 'BodyOneText',
        semanticTag: 'p',
        defaultVisualAppearance: 'body-one',
    },
    {
        displayName: 'BodyTwoText',
        semanticTag: 'p',
        defaultVisualAppearance: 'body-two',
    },
    {
        displayName: 'BodyThreeText',
        semanticTag: 'p',
        defaultVisualAppearance: 'body-three',
    },
    {
        displayName: 'BodyFourText',
        semanticTag: 'p',
        defaultVisualAppearance: 'body-four',
    },
    {
        displayName: 'OverlineOneText',
        semanticTag: 'p',
        defaultVisualAppearance: 'overline-one',
    },
    {
        displayName: 'OverlineTwoText',
        semanticTag: 'p',
        defaultVisualAppearance: 'overline-two',
    },
    {
        displayName: 'OverlineThreeText',
        semanticTag: 'p',
        defaultVisualAppearance: 'overline-three',
    },
    { displayName: 'EmText', semanticTag: 'em', defaultVisualAppearance: 'em' },
    {
        displayName: 'StrongText',
        semanticTag: 'strong',
        defaultVisualAppearance: 'strong',
    },
    {
        displayName: 'ExtraStrongText',
        semanticTag: 'strong',
        defaultVisualAppearance: 'extra-strong',
    },
    {
        displayName: 'Figcaption',
        semanticTag: 'figcaption',
        defaultVisualAppearance: 'figcaption',
    },
];
// Generates a set of components(Typography Elements) based on the data in typographyElementsToGenerate
var generateComponents = function (componentsToGenerate) {
    return componentsToGenerate.reduce(function (acc, componentTemplateData) {
        var _a;
        var displayName = componentTemplateData.displayName, semanticTag = componentTemplateData.semanticTag, defaultVisualAppearance = componentTemplateData.defaultVisualAppearance;
        var TypographyElement = function (componentProps) {
            var visualAppearance = componentProps.visualAppearance, children = componentProps.children, className = componentProps.className, style = componentProps.style;
            return (React.createElement(Typography, { semanticTag: semanticTag, visualAppearance: visualAppearance || defaultVisualAppearance, className: className, style: style }, children));
        };
        TypographyElement.displayName = displayName;
        return __assign(__assign({}, acc), (_a = {}, _a[displayName] = TypographyElement, _a));
    }, {});
};
export var Heading1 = (_a = generateComponents(typographyElementsToGenerate), _a.Heading1), Heading2 = _a.Heading2, Heading3 = _a.Heading3, Heading4 = _a.Heading4, Heading5 = _a.Heading5, Heading6 = _a.Heading6, BodyOneText = _a.BodyOneText, BodyTwoText = _a.BodyTwoText, BodyThreeText = _a.BodyThreeText, BodyFourText = _a.BodyFourText, OverlineOneText = _a.OverlineOneText, OverlineTwoText = _a.OverlineTwoText, OverlineThreeText = _a.OverlineThreeText, EmText = _a.EmText, StrongText = _a.StrongText, ExtraStrongText = _a.ExtraStrongText, Figcaption = _a.Figcaption;
